import { __assign } from "tslib";
export var testDataCreator = function (defaults) {
    return function (partial) {
        if (partial === void 0) { partial = {}; }
        // tslint:disable-next-line:ban-types
        var objDefaults = (typeof defaults === 'function' ? defaults() : defaults);
        var objPartial = partial;
        // tslint:disable-next-line:no-object-literal-type-assertion
        var ret = __assign(__assign({}, objDefaults), objPartial);
        return ret;
    };
};
//# sourceMappingURL=index.js.map